import React, { useEffect, useState } from "react";
import Topbar from "../components/Topbar";
import useLang from "../hooks/useLang";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Switch } from "../components/ui/switch";
import { toast } from "sonner";

export default function Settings() {
  const { t } = useLang();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [daily, setDaily] = useState(true);
  const [phone, setPhone] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!user) navigate("/login");
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setDaily(data.daily_email_enabled !== false);
        setPhone(data.phone || "");
      } catch {}
    })();
  }, [user, navigate]);

  const save = async () => {
    setSaving(true);
    try {
      await api.patch("/auth/prefs", { daily_email_enabled: daily, phone: phone || null });
      toast.success(t("saved"));
    } catch (err) {
      toast.error(err.response?.data?.detail || t("errorGeneric"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Topbar />
      <main className="max-w-3xl mx-auto px-6 md:px-10 py-10">
        <div className="overline mb-3">/// {t("settings")}</div>
        <h1 className="font-heading text-4xl tracking-tight font-light mb-10">{t("settingsTitle")}</h1>
        <div className="space-y-6">
          <div className="border border-zinc-200 rounded-md p-6">
            <div className="flex items-start justify-between gap-6">
              <div>
                <Label className="overline">/// Email</Label>
                <p className="text-sm font-medium mt-1">{t("dailyEmailEnabled")}</p>
              </div>
              <Switch checked={daily} onCheckedChange={setDaily} data-testid="daily-email-switch" />
            </div>
          </div>
          <div className="border border-zinc-200 rounded-md p-6 space-y-3">
            <Label className="overline">{t("phoneLabel")}</Label>
            <Input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder={t("phonePh")} data-testid="phone-input" className="rounded-md border-zinc-200 h-11" />
          </div>
          <Button onClick={save} disabled={saving} data-testid="settings-save-btn" className="bg-zinc-950 hover:bg-zinc-800 rounded-md h-11 px-6">
            {saving ? t("loading") : t("save")}
          </Button>
        </div>
      </main>
    </div>
  );
}
